var map = {
	"./clipboard-controller.js": 40,
	"./color-scheme-controller.js": 181,
	"./image-size-controller.js": 149,
	"./jump-targets-controller.js": 519,
	"./limit-height-controller.js": 613,
	"./metawizard-controller.js": 508,
	"./scroll-offset-controller.js": 267,
	"./toggle-fieldset-controller.js": 435,
	"./toggle-navigation-controller.js": 833,
	"./toggle-nodes-controller.js": 926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 520;